const ALLOWED_TAGS = {
  p: [],
  br: [],
  strong: [],
  b: [],
  em: [],
  i: [],
  u: [],
  span: [],
  div: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  ul: [],
  ol: [],
  li: [],
  a: ['href', 'title', 'target'],
  img: ['src', 'alt', 'width', 'height'],
  table: [],
  thead: [],
  tbody: [],
  tr: [],
  td: [],
  th: [],
  blockquote: [],
  pre: [],
  code: [],
  hr: [],
  section: [],
  article: [],
};

function sanitizeHtml(dirty) {
  if (!dirty || typeof dirty !== 'string') {
    return '';
  }

  const temp = document.createElement('div');
  temp.innerHTML = dirty;

  const walk = node => {
    for (let n = 0; n < node.childNodes.length; n++) {
      const child = node.childNodes[n];

      if (child.nodeType === 1) {
        const tagName = child.tagName.toLowerCase();

        if (!(tagName in ALLOWED_TAGS)) {
          while (child.firstChild) {
            node.insertBefore(child.firstChild, child);
          }
          node.removeChild(child);
          n--;
          continue;
        }

        const allowedAttrs = ALLOWED_TAGS[tagName];
        const attrs = Array.from(child.attributes);

        attrs.forEach(attr => {
          const attrName = attr.name.toLowerCase();

          if (!allowedAttrs.includes(attrName)) {
            child.removeAttribute(attr.name);
          }

          if ((attrName === 'href' || attrName === 'src') && child.hasAttribute(attr.name)) {
            const value = child.getAttribute(attr.name).toLowerCase();
            const dangerousProtos = ['javascript:', 'data:', 'vbscript:', 'file:', 'about:'];

            if (dangerousProtos.some(proto => value.startsWith(proto))) {
              child.removeAttribute(attr.name);
            }
          }
        });

        walk(child);
      }
    }
  };

  walk(temp);
  return temp.innerHTML;
}

export default sanitizeHtml;
